import axios from 'axios'
import { API_KEY, API_URL, CUSTOMERS_KEY } from '../keys'
import ProductEntity from '@/entities/api/products/products'
import { Entities } from '@/entities/api/entities'

export const createProduct = async (
	token: string,
	productData: Partial<ProductEntity>,
	imageFiles: File[]
) => {
	const formData = new FormData()
	formData.append('productData', JSON.stringify(productData))
	imageFiles.forEach((file) => {
		formData.append('files', file)
	})

	const response = await axios.post(`${API_URL}/products`, formData, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'multipart/form-data',
		},
		validateStatus: (status) => status < 500,
	})

	if (response) return response
}

export const fetchProducts = async ({
	token,
	limit,
	offset,
	category,
	type,
}: {
	limit?: number
	offset?: number
	category?: string
	type?: Entities
	token: string
}) => {
	const params: Record<string, any> = {}

	if (limit !== undefined) params.limit = limit
	if (offset !== undefined) params.offset = offset
	if (category) params.category = category
	if (type) params.type = type

	const response = await axios.get(`${API_URL}/products`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-key': CUSTOMERS_KEY,
			'Content-Type': 'application/json',
		},
		params,
		validateStatus: (status) => status < 500,
	})

	if (response) return response
}

export const removeProductById = async (token: string, id: string) => {
	const response = await axios.delete(`${API_URL}/products/${id}`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}

export const updateProductById = async ({
	product,
	token,
	id,
}: {
	product: Partial<ProductEntity>
	token: string
	id: string
}) => {
	const response = await axios.patch(`${API_URL}/products/${id}`, product, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}
